import { createContext, useContext } from "react";
import { UserContextProps } from "../../types";

export const UserContext = createContext<UserContextProps | undefined>(
  undefined,
);

export const useUserContext = (): UserContextProps => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }

  return context;
};
